module.exports = __webpack_public_path__ + "img/logo_imca_cat.88c3c2f4.png";